module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("user_profile", [["div",{"class":"user-notitfications border-color-3-trans-20"},[["div",{"class":"global-title"},[["textNode",{"text":"Member profile"}]]],["div",{"class":"user-profile-table"},[["table",{},[["tr",{},[["td",{},[["strong",{},[["textNode",{"text":"Username"}]]]]],["td",{},[["span",{},[],[["login","__text",true]]]]]]],["tr",{},[["td",{},[["strong",{},[["textNode",{"text":"Email"}]]]]],["td",{},[["span",{},[],[["email","__text",true]]]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/user/profile.tpl
// module id = 1259
// module chunks = 4